function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccomodation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 52,
    viewBox: "0 0 53 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 0.918945,
    width: 52,
    height: 52,
    rx: 6,
    fill: "#CA0C64",
    fillOpacity: 0.08,
    style: {
      fill: "#CA0C64",
      fill: "color(display-p3 0.7922 0.0471 0.3922)",
      fillOpacity: 0.08
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1981 18.5653H34.0106V17.2528C34.0106 15.8604 33.4574 14.5251 32.4729 13.5406C31.4882 12.5561 30.1529 12.0029 28.7607 12.0029H25.2607C23.8683 12.0029 22.533 12.5561 21.5485 13.5406C20.5639 14.5253 20.0108 15.8606 20.0108 17.2528V18.5653H17.8233C16.5469 18.5653 15.3229 19.0723 14.4202 19.9748C13.5177 20.8774 13.0107 22.1015 13.0107 23.3778V35.1904C13.0107 36.4667 13.5177 37.6908 14.4202 38.5934C15.3229 39.4959 16.5469 40.0029 17.8233 40.0029H36.1984C37.4747 40.0029 38.6988 39.4959 39.6014 38.5934C40.5039 37.6908 41.0109 36.4667 41.0109 35.1904V23.3778C41.0109 22.1015 40.5039 20.8774 39.6014 19.9748C38.6988 19.0723 37.4747 18.5653 36.1984 18.5653H36.1981ZM30.5105 22.0653V36.5029H23.5105V22.0653H30.5105ZM23.5105 17.2528C23.5105 16.7887 23.6949 16.3436 24.0231 16.0154C24.3513 15.6872 24.7964 15.5028 25.2605 15.5028H28.7605C29.2247 15.5028 29.6697 15.6872 29.998 16.0154C30.3261 16.3436 30.5105 16.7887 30.5105 17.2528V18.5653H23.5105V17.2528ZM16.5105 35.1904V23.3778C16.5105 23.0298 16.6488 22.696 16.8949 22.4497C17.1411 22.2036 17.4749 22.0653 17.823 22.0653H20.0105V36.5029H17.823C17.4749 36.5029 17.1411 36.3646 16.8949 36.1185C16.6488 35.8723 16.5105 35.5385 16.5105 35.1904ZM37.5106 35.1904C37.5106 35.5385 37.3723 35.8723 37.1262 36.1185C36.88 36.3646 36.5461 36.5029 36.1981 36.5029H34.0106V22.0653H36.1981C36.5461 22.0653 36.88 22.2036 37.1262 22.4497C37.3723 22.696 37.5106 23.0298 37.5106 23.3778V35.1904Z",
    fill: "#CA0C64",
    style: {
      fill: "#CA0C64",
      fill: "color(display-p3 0.7922 0.0471 0.3922)",
      fillOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccomodation);
export default __webpack_public_path__ + "static/media/accomodation.05cc64a475484f3e2f86c02270c9ed31.svg";
export { ForwardRef as ReactComponent };